import {Component, Input, OnInit} from '@angular/core';
import {CustomFormControl} from '../controls/CustomFormControl';
import {Parcel} from '../../../../_models/parcel';
import {FileOnlineViewModel} from '../../FileOnlineViewModel';

@Component({
  selector: 'app-existing-address',
  templateUrl: './existing-address.component.html',
  styleUrls: ['./existing-address.component.scss']
})
export class ExistingAddressComponent implements OnInit {

  @Input() control!: CustomFormControl;
  @Input() viewModel: FileOnlineViewModel;

  constructor() { }

  ngOnInit(): void {
  }

  getControlId(parcel: Parcel): string {
    return parcel.AIN;
  }

  getAddressLabel(parcel: Parcel): string {
    return parcel.SitusStreet + ', ' + parcel.SitusCity + ', ' + parcel.SitusZipCode;
  }
}
